var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFilterSettingSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.518,
    height: 11.518,
    viewBox: "0 0 11.518 11.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71109",
    "data-name": "Path 71109",
    d: "M16.368,14.934A1.434,1.434,0,1,1,14.934,13.5,1.434,1.434,0,0,1,16.368,14.934Z",
    transform: "translate(-8.175 -8.175)",
    fill: "none",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71110",
    "data-name": "Path 71110",
    d: "M10.3,8.193a.789.789,0,0,0,.158.87l.029.029A.957.957,0,1,1,9.13,10.445L9.1,10.416a.8.8,0,0,0-1.348.564v.081a.956.956,0,0,1-1.912,0v-.043a.828.828,0,0,0-1.386-.564l-.029.029A.957.957,0,1,1,3.073,9.13L3.1,9.1a.8.8,0,0,0-.564-1.348H2.456a.956.956,0,1,1,0-1.912H2.5a.828.828,0,0,0,.564-1.386l-.029-.029A.957.957,0,1,1,4.388,3.073l.029.029a.789.789,0,0,0,.87.158h.038A.789.789,0,0,0,5.8,2.537V2.456a.956.956,0,0,1,1.912,0V2.5a.8.8,0,0,0,1.348.564l.029-.029a.957.957,0,1,1,1.353,1.353l-.029.029a.789.789,0,0,0-.158.87v.038a.789.789,0,0,0,.722.478h.081a.956.956,0,0,1,0,1.912h-.043a.789.789,0,0,0-.722.478Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f45e29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSettingSmall);
export default __webpack_public_path__ + "static/media/icon-filter-setting-small.0a96aa92.svg";
export { ForwardRef as ReactComponent };